<template>
  <div class="w-full">
    <p class="gm-admin-modal__section-title">
      {{ this.$t('frontend_groovemail_admin_import_user_approval_csv_file_of_leads_import_analysis') }}
    </p>
    <dl class="gm-admin-stats">
      <div>
        <dt>{{ this.$t('frontend_groovemail_admin_import_user_approval_csv_file_of_leads_total') }}</dt>
        <dd>{{ importData.total_leads ? importData.total_leads : 0 }}</dd>
      </div>
      <div>
        <dt>{{ this.$t('frontend_groovemail_admin_import_user_approval_csv_file_of_leads_bad') }}</dt>
        <dd>{{
          importData.block_lead +
          importData.bounce_lead +
          importData.suppression_lead
            ? importData.block_lead +
              importData.bounce_lead +
              importData.suppression_lead
            : 0
        }}</dd>
      </div>
      <div>
        <dt>{{ this.$t('frontend_groovemail_admin_import_user_approval_csv_file_of_leads_good') }}</dt>
        <dd>{{ importData.good_leads ? importData.good_leads : 0 }}</dd>
      </div>
      <div>
        <dt>{{ this.$t('frontend_groovemail_admin_import_user_approval_csv_file_of_leads_lists') }}</dt>
        <dd>{{ importData.list_counts ? importData.list_counts : 0 }}</dd>
      </div>
      <div>
        <dt>{{ this.$t('frontend_groovemail_admin_import_user_approval_csv_file_of_leads_tags') }}</dt>
        <dd>{{ importData.tag_counts ? importData.tag_counts : 0 }}</dd>
      </div>
    </dl>

    <p class="gm-admin-modal__section-title">
      {{ this.$t('frontend_groovemail_admin_import_user_approval_csv_file_of_leads_field_mappings') }}
    </p>
    <div class="gm-admin-kv">
      <div class="gm-admin-kv__head">
        <p class="w-1/2">
          {{ this.$t('frontend_groovemail_leads_import_multiple_leads_header') }}
        </p>
        <p class="w-1/2">
          {{ this.$t('frontend_groovemail_leads_import_multiple_leads_field') }}
        </p>
      </div>
      <template
        v-if="
          importData &&
          importData.all_headers_mapping &&
          importData.all_headers_mapping.length
        "
      >
        <div
          class="gm-admin-kv__row"
          v-for="(mapping, index) in importData.all_headers_mapping"
          :key="index"
        >
          <p class="w-1/2">{{ mapping.name }}</p>
          <p class="w-1/2" v-if="mapping.key">{ {{ mapping.key }} }</p>
          <p class="w-1/2" v-else>{{ $t('frontend_groovemail_not_available') }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'import-mapping-and-analysis',
  props: {
    importData: {
      required: true,
    },
  },

  components: {
    VuePerfectScrollbar,
  },
};
</script>
